import { components } from '@/generated/internal-api/openapi-types';
import type { Preset } from '@/model/Preset.model';

export type WeightPercentageChange = components['schemas']['WeightPercentageChange.schema'];
export type PercentChangeSettings = Record<Preset['id'], WeightPercentageChange>;

export const PercentChangeMap = {
  fromFirstMeasurement: 'first_measurement',
  fromLatestMeasurement: 'latest_measurement',
  fromMaximumMeasurement: 'maximum_measurement',
  trackingDate: 'tracking_date',
} satisfies Record<string, WeightPercentageChange>;

export const PercentChangeFromOptions: Array<{ value: WeightPercentageChange; label: string }> = [
  { value: 'first_measurement', label: 'First measurement' },
  { value: 'latest_measurement', label: 'Latest measurement' },
  { value: 'maximum_measurement', label: 'Max measurement' },
  { value: 'tracking_date', label: 'Tracking date' },
];

export const getPercentChangeOptions = (
  maxWeightAlertsEnabled: boolean
): Array<{ value: WeightPercentageChange; label: string }> =>
  maxWeightAlertsEnabled
    ? PercentChangeFromOptions
    : PercentChangeFromOptions.filter((option) => option.value !== 'maximum_measurement');
